const consent_modal = require('./en/consent_modal')
const settings_modal  = require('./en/settings_modal')

module.exports = {
    callLinkName: 'Cookie settings',
    consent_modal,
    settings_modal
}
